import { PropsWithChildren, useState } from 'react';

import { AnimatePresence, motion } from 'motion/react';

import { Stack, u, Inline, Box, FilterIcon, Text } from '@ui';

import * as css from './MobileActivityFilterLayout.css';

type MobileActivityFilterLayoutProps = {
    numberOfVisibleActivities?: number;
    totalActivities?: number | null;
    emptyFilter?: boolean;
    clearFilter: () => void;
};

export const MobileActivityFilterLayout = ({
    numberOfVisibleActivities,
    totalActivities,
    emptyFilter,
    clearFilter,
    children,
}: PropsWithChildren<MobileActivityFilterLayoutProps>) => {
    const [isFilterSectionOpen, setIsFilterSectionOpen] = useState(false);
    return (
        <Stack my={u(1)} className={css.sticky}>
            <Inline
                p={u(2)}
                justifyContent="space-between"
                role="button"
                onClick={() => setIsFilterSectionOpen(!isFilterSectionOpen)}
            >
                <Inline>
                    <Text variant="h3">
                        Activities
                        <Box
                            display="inline-flex"
                            ml={u(1)}
                            justifyContent="flex-end"
                            style={{ minWidth: '9ch', fontWeight: 400, fontVariantNumeric: 'tabular-nums' }}
                        >
                            {numberOfVisibleActivities}/{totalActivities}
                        </Box>
                    </Text>
                </Inline>
                <Inline gap={u(2)}>
                    <AnimatePresence initial={false}>
                        {!emptyFilter && (
                            <motion.button
                                type="button"
                                initial={{ opacity: 0, x: 8 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 8 }}
                                transition={{
                                    duration: 0.2,
                                    ease: 'easeOut',
                                }}
                                onClick={(evt) => {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    clearFilter();
                                }}
                            >
                                <Text variant="h4">reset filters</Text>
                            </motion.button>
                        )}
                    </AnimatePresence>
                    <FilterIcon />
                </Inline>
            </Inline>

            <AnimatePresence initial={false}>
                {isFilterSectionOpen && (
                    <motion.div
                        initial={{ height: 0, opacity: 0, y: -8 }}
                        animate={{ height: 'auto', opacity: 1, y: 0 }}
                        exit={{ height: 0, opacity: 0, y: -8 }}
                        transition={{
                            duration: 0.2,
                            ease: 'easeOut',
                        }}
                        style={{ overflow: 'hidden' }}
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </Stack>
    );
};
